// extracted by mini-css-extract-plugin
export default {"link":"MJ-z","disabled":"NJ-z"};